<div class="dialog-content">
  <div class="close" (click)="rowanBeanDialogRef.close()"></div>

  <div class="external-wrapper" (click)="rowanBeanDialogRef.close()"></div>

  <video controls poster="/assets/img/anatomy/tutorial-ankylosaurus.png">
    <source src="/assets/videos/tutorial-ankylosaurus.mp4" type="video/mp4">
    <img src="/assets/img/anatomy/tutorial-ankylosaurus.png">
    Sorry, your browser doesn't support embedded videos.
  </video>
</div>
